<template>
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="开票抬头" prop="invoiceTitle">
            <el-input v-model="form.invoiceTitle"></el-input>
        </el-form-item>
        <el-form-item label="开票类型" prop="invoiceType">
            <el-select style="width: 100%;" v-model="form.invoiceType" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="开票电话" prop="mobile">
            <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="dutyNo">
            <el-input v-model="form.dutyNo"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="bankName">
            <el-input v-model="form.bankName"></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="bankNo">
            <el-input v-model="form.bankNo"></el-input>
        </el-form-item>
        <el-form-item label="省市区" prop="pca">
            <el-cascader
                style="width: 100%"
                :options="areaAddress"
                :props="props"
                v-model="form.pca"
            ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
            <el-input v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item v-if="!isFromOrder">
            <el-button type="success" @click="onSubmit()">保存</el-button>
            <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import * as apis from '../../fetch/user';
import { address } from '../../fetch/address';

export default {
    name: 'UserInvoice',
    props: ['from'],
    data() {
        return {
            form: {
                invoiceTitle: '',
                invoiceType: '',
                mobile: '',
                dutyNo: '',
                bankName: '',
                bankNo: '',
                address: '',
                pca: '',
            },
            props: {
                value: 'label',
                children: 'children',
            },
            options: [
                {
                    value: 1,
                    label: '专票',
                },
                {
                    value: 2,
                    label: '普票',
                },
            ],
        };
    },
    computed: {
        isFromOrder() {
            return this.from === 'order';
        },
        areaAddress() {
            return address;
        },
        rules() {
            return {
                invoiceTitle: [{ required: true, message: '请输入开票抬头' }],
                invoiceType: [{ required: true, message: '请输入开票类型' }],
                mobile: [
                    {
                        required: this.form.invoiceType === 1,
                        message: '请输入开票电话',
                    },
                ],
                dutyNo: [{ required: true, message: '请输入税号' }],
                bankName: [
                    {
                        required: this.form.invoiceType === 1,
                        message: '请输入开户行',
                    },
                ],
                bankNo: [
                    {
                        required: this.form.invoiceType === 1,
                        message: '请输入银行卡号',
                    },
                ],
                address: [
                    {
                        required: this.form.invoiceType === 1,
                        message: '请输入详细地址',
                    },
                ],
                pca: [
                    {
                        required: this.form.invoiceType === 1,
                        message: '请选择省市区',
                    },
                ],
            };
        },
    },
    methods: {
        onSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    const params = {
                        ...this.form,
                        province: this.form.pca[0],
                        city: this.form.pca[1],
                        area: this.form.pca[2],
                    };
                    delete params.pca;
                    delete params.id;
                    delete params.userId;
                    apis.setUserInvoice(params).then(res => {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                        });
                    });
                }
            });
        },
        resetForm() {
            this.$refs['form'].resetFields();
            this.form.pca = [];
        },
        getAddress() {
            apis.getUserInvoice().then(item => {
                if (item) {
                    Object.keys(item).forEach(key => {
                        if (this.form[key] === '' || this.form[key]) {
                            this.form[key] = item[key];
                        }
                    });
                    this.form.pca = [item.province, item.city, item.area];
                }
            });
        },
    },
    mounted() {
        this.getAddress();
    },
};
</script>


<style scoped lang="scss">
</style>